import * as React from "react";
import { Grid } from "@mui/material";
import { JournalctlLog } from "../../../components/log_tab/journal_ctl_log";
import ActivityCard from "../../../components/general_tab/activity_card";

export default function LogTab({ required_privilege }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <JournalctlLog />
          <ActivityCard sx={{ mt: 2 }} /> {/* Site activity */}
        </Grid>
      </Grid>
    </>
  );
}
